import { minutesToTime, timeToMinutes } from "utils";

export const readTime = data => {
    const newData = data.map((time, i) => ({
        ...time,
        id: i + 1,
        start: `00/00/00 ${minutesToTime(time.start)}`,
        end: `00/00/00 ${minutesToTime(time.end)}` 
    }))

    return newData;
}

export const sendTime = data => {
    const newData = data.map(time => {
        const thisData = {
            ...time,
            start: timeToMinutes(time.start.replace("00/00/00 ", "")),
            end: timeToMinutes(time.end.replace("00/00/00 ", ""))
        }

        delete thisData.id;
        delete thisData.error;
        
        return thisData;
    })

    return newData;
}